import React from 'react';
import { AddressType } from '../CommonTypes';
import SelectableAddress from './SelectableAddress';
import './SelectableAddresses.scss';

type SelectableAddressesProps = {
    id: string;
    addresses: AddressType[];
    selectedId: string | null;
    onSelectionChanged: (selectedId: string | null) => void;
    onEditAddressClick: (id: string) => void;
    editable?: boolean;
};

const SelectableAddresses = React.memo(SelectableAddressesMemo);

function SelectableAddressesMemo({
    id,
    addresses,
    selectedId,
    onSelectionChanged,
    onEditAddressClick,
    editable
}: SelectableAddressesProps): JSX.Element {
    const onAddressClicked = (selected: boolean, addressId: string) => {
        onSelectionChanged(selected ? addressId : null);
    };

    const renderSelectableAddress = (address: AddressType, index: number) => {
        return (
            <SelectableAddress
                id={`${id}-${index}-address`}
                key={`${id}-${address.id}`}
                onClicked={(selected: boolean) => {
                    onAddressClicked(selected, address.id);
                }}
                onEditSelectedAddress={() => {
                    onEditAddressClick(address.id);
                }}
                selected={address.id === selectedId}
                style={{ border: '1px solid lightgray', marginRight: '7px' }}
                address={address}
                editable={editable || index != 0}
            />
        );
    };

    return (
        <div id={id} className='selectableAddresses--container'>
            {addresses.map((address, index) =>
                renderSelectableAddress(address, index)
            )}
        </div>
    );
}

export default SelectableAddresses;
